module.exports = require("fs-extra-promise");


//////////////////
// WEBPACK FOOTER
// external "fs-extra-promise"
// module id = 13
// module chunks = 0